import React, { useState, useEffect } from 'react';
import {
    Table,
    Sheet,
    Typography,
    Box,
    Chip,
    CircularProgress
} from '@mui/joy';
import Pagination from '@mui/material/Pagination';
import axios from 'axios';
import domain from "../../../util/domain";

export default function RecentResponses() {
    const [data, setData] = useState({ data: [], pagination: {} });
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchRecent = async () => {
            try {
                setLoading(true);
                const response = await axios.get(`${domain}/frontoffice/feedback/recent`, {
                    params: { page, limit: 10 }
                });
                setData(response.data);
            } catch (error) {
                console.error('Error fetching recent responses:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchRecent();
    }, [page]);

    const getRatingColor = (rating, type) => {
        if (type === 'response' || type === 'interaction') {
            if (rating >= 4) return 'success';
            if (rating >= 3) return 'warning';
            return 'danger';
        }
        return rating === 1 ? 'success' : 'neutral';
    };

    if (loading) return <CircularProgress />;

    return (
        <Box>
            <Sheet variant="outlined" sx={{ borderRadius: 'md', overflow: 'auto' }}>
                <Table stickyHeader hoverRow>
                    <thead>
                        <tr>
                            <th>Comments</th>
                            <th>Response Rating</th>
                            <th>Counsellor Clarity</th>
                            <th>Needs Info</th>
                            <th>Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.data.map(item => (
                            <tr key={item.id}>
                                <td>
                                    <Typography level="body-sm">
                                        {item.comments}
                                    </Typography>
                                </td>
                                <td>
                                    <Chip
                                        size="sm"
                                        variant="soft"
                                        color={getRatingColor(item.response_rating, 'response')}
                                    >
                                        {item.response_rating}/4
                                    </Chip>
                                </td>
                                <td>
                                    <Chip
                                        size="sm"
                                        variant="soft"
                                        color={getRatingColor(item.counsellor_clarity, 'clarity')}
                                    >
                                        {item.counsellor_clarity ? 'Yes' : 'No'}
                                    </Chip>
                                </td>
                                <td>
                                    <Chip
                                        size="sm"
                                        variant="soft"
                                        color={getRatingColor(item.needs_more_info, 'info')}
                                    >
                                        {item.needs_more_info ? 'Yes' : 'No'}
                                    </Chip>
                                </td>
                                <td>
                                    <Typography level="body-sm">
                                        {new Date(item.createdAt).toLocaleDateString()}
                                    </Typography>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </Sheet>

            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mt: 2
                }}
            >
                <Pagination
                    count={data.pagination?.total_pages || 1}
                    page={page}
                    onChange={(event, value) => setPage(value)}
                />
            </Box>
        </Box>
    );
} 